module.exports = __webpack_public_path__ + "img/ywc.99abb41d.png";